import './_carousel-cards.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { SPINNER_DURATION } from '@/ts/enums';

export default function MiniCarousel() {
    const carouselCards = document.querySelectorAll('.carousel-cards');

    if (carouselCards.length > 0) {
        let requests: any = [];

        carouselCards.forEach((item, index) => {
            if (item) {
                item.classList.add('has-spinner');
                const $config = JSON.parse(<string>item.querySelector('#service-config')?.innerHTML);
                const carouselWrapper = item.querySelector('.carousel-cards-wrapper') as HTMLElement;
                const swiperContainer = carouselWrapper.querySelector('.swiper-container') as HTMLElement;
                let totalNews: any[] = [];

                swiperContainer.setAttribute('id', `swiper-cards-${index}`);

                $config.forEach((url: any) => {
                    const request = getNews(url.value)
                        .then((response: any) => response.json())
                        .then(response => {
                            if (response.result === 'OK') {
                                totalNews.push(response.data);
                            }
                        })
                        .catch(() => {
                            console.error();
                        });
                    requests.push(request);
                });

                Promise.all(requests)
                    .then(() => {
                        let totalResponsesArray = [].concat.apply([], totalNews);
                        totalResponsesArray.forEach((item: any) => {
                            if (item.sorting_date_timestamp) {
                                totalResponsesArray.sort((a: any, b: any) => {
                                    return parseInt(b.sorting_date_timestamp) - parseInt(a.sorting_date_timestamp);
                                });
                            } else {
                                totalResponsesArray.sort((a: any, b: any) => {
                                    return parseInt(b.published_at_timestamp) - parseInt(a.published_at_timestamp);
                                });
                            }
                        });
                        setTimeout(() => {
                            create(totalResponsesArray, item, <any>swiperContainer, <any>carouselWrapper);
                            item.classList.remove('has-spinner');
                        }, SPINNER_DURATION);
                    })
                    .catch(() => {
                        item.classList.remove('has-spinner');
                        console.error();
                    });
            }
        });

        function create(data: any, item: any, swiperContainer: any, carouselWrapper: any) {
            const $wrapperArrow = carouselWrapper.querySelector('.buttons') as HTMLElement;
            const swiperBtnNext = carouselWrapper.querySelector('.swiper-button-next') as HTMLElement;
            const swiperBtnPrev = carouselWrapper.querySelector('.swiper-button-prev') as HTMLElement;
            const swiperPagination = carouselWrapper.querySelector('.swiper-pagination') as HTMLElement;

            $wrapperArrow.classList.remove('d-none');

            data.forEach((card: any) => {
                const cloneCard = item.querySelector('.swiper-slide.d-none').cloneNode(true);
                cloneCard.querySelector('.card-title').innerHTML = card.title;
                cloneCard.querySelector('.date').innerHTML = card.sorting_date;
                cloneCard.querySelector('.link>a').setAttribute('href', card.uri);

                const newsBadgeNode = cloneCard.querySelector('.news-badge');
                if (newsBadgeNode) {
                    const cardUri = new URL(card.uri);
                    const newsTheme = cardUri.pathname.split('/')[1] || '';
                    newsBadgeNode.setAttribute('data-theme', newsTheme.toLowerCase());
                    newsBadgeNode.innerHTML = newsTheme.toUpperCase();
                }

                cloneCard.classList.remove('d-none');
                swiperContainer.querySelector('.swiper-wrapper').appendChild(cloneCard);
            });

            const containerNews = carouselWrapper.querySelector('.swiper-container') as HTMLElement;

            const swiper = new Swiper(containerNews, {
                modules: [Navigation, Pagination],
                pagination: {
                    el: swiperPagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperBtnNext,
                    prevEl: swiperBtnPrev,
                    addIcons: false,
                },
                breakpoints: {
                    0: {
                        loop: data.length > 1,
                        spaceBetween: 0,
                        slidesPerView: 1.3,
                        slidesPerGroup: 1,
                    },
                    768: {
                        loop: data.length > 2,
                        spaceBetween: 28,
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    1060: {
                        loop: data.length > 4,
                        spaceBetween: 28,
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                },
                on: {
                    afterInit: function () {
                        const bullets = swiperPagination.querySelectorAll('.swiper-pagination-bullet');
                        bullets.forEach((bullet: any) => {
                            bullet.setAttribute('tabindex', '0');
                            bullet.addEventListener('keydown', (event: any) => {
                                if (event.key === 'ArrowLeft') {
                                    event.preventDefault();
                                    swiper.slidePrev();
                                } else if (event.key === 'ArrowRight') {
                                    event.preventDefault();
                                    swiper.slideNext();
                                }
                            });
                        });
                    },
                    slideChange: function () {
                        const currentSlide = swiperPagination.querySelector('.swiper-pagination-bullet.swiper-pagination-bullet-active') as HTMLDivElement;
                        if (currentSlide) {
                            currentSlide.focus();
                        }
                    },
                },
            });

            if (swiperBtnNext) {
                swiperBtnNext.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        swiper.slideNext();
                    }
                });
            }

            if (swiperBtnPrev) {
                swiperBtnPrev.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        swiper.slidePrev();
                    }
                });
            }

            swiper.init();
        }

        function getNews(url: string) {
            return fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        }
    }
}
